var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog, Heading, Icon, NavBarItem, NavBarItemIcon, NavBarItemIconWrapper, NavBarItemText, P, withClassName, } from '@a-type/ui';
import { graphql, useQuery } from '@biscuits/graphql';
import { useState } from 'react';
import { useLocalStorage } from '../hooks/useStorage.js';
import cls from './Changelog.module.css';
import { useAppId } from './Context.js';
const changelogQuery = graphql(`
	query ChangelogMain($appId: String!) {
		changelog(appId: $appId) {
			id
			title
			details
			createdAt
			imageUrl
		}
	}
`);
export function ChangelogDisplay(_a) {
    var _b;
    var { children, hideOnSeen, className } = _a, rest = __rest(_a, ["children", "hideOnSeen", "className"]);
    const [seen, setSeen] = useLocalStorage('changelog-seen', null);
    const [capturedSeen] = useState(seen);
    const appId = useAppId();
    const res = useQuery(changelogQuery, { variables: { appId } });
    const data = ((_b = res.data) === null || _b === void 0 ? void 0 : _b.changelog) || [];
    const lastSeenIndex = data.findIndex((x) => x.id === capturedSeen);
    const hasUnseen = !!data.length && lastSeenIndex !== 0;
    const hasNew = !!data.length && data.findIndex((x) => x.id === seen) !== 0;
    if (!hasUnseen && hideOnSeen)
        return null;
    return (_jsxs(Dialog, Object.assign({}, rest, { onOpenChange: (open) => {
            var _a;
            (_a = rest.onOpenChange) === null || _a === void 0 ? void 0 : _a.call(rest, open);
            if (open && data[0]) {
                setSeen(data[0].id.toString());
            }
        }, children: [_jsx(Dialog.Trigger, { className: className, "data-new": hasNew, render: () => children || (_jsx(Button, { emphasis: hasNew ? 'light' : 'ghost', color: "accent", children: _jsx(Icon, { name: "gift" }) })) }), _jsxs(Dialog.Content, { children: [_jsx(Dialog.Title, { children: "What's new" }), _jsx(Box, { col: true, gap: true, overflow: "auto-y", children: data.map((item, idx) => (_jsxs("div", { style: { position: 'relative' }, children: [_jsx(P, { italic: true, emphasis: "ambient", children: new Date(item.createdAt).toLocaleDateString() }), _jsx(Heading, { render: _jsx("h3", {}), emphasis: "ambient", children: item.title }), item.imageUrl && (_jsx("img", { src: item.imageUrl, alt: item.title, style: {
                                        height: 'auto',
                                        width: '100%',
                                    } })), _jsx(P, { children: item.details }), (lastSeenIndex === -1 || idx < lastSeenIndex) && (_jsx("div", { className: cls.pip }))] }, item.id))) }), _jsx(Dialog.Actions, { children: _jsx(Dialog.Close, {}) })] })] })));
}
export function NavBarChangelog() {
    return (_jsx(ChangelogDisplay, { hideOnSeen: true, className: cls.desktopOnly, children: _jsxs(NavBarChangelogButton, { children: [_jsx(NavBarItemIconWrapper, { children: _jsx(NavBarItemIcon, { name: "gift" }) }), _jsx(NavBarItemText, { children: "What's new" })] }) }));
}
const NavBarChangelogButton = withClassName(NavBarItem, cls.changelogItem);
//# sourceMappingURL=Changelog.js.map